/* eslint-disable no-nested-ternary */
/* eslint-disable no-sequences */
/* eslint-disable indent */
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { format } from 'date-fns';
import { map, findIndex, get } from 'lodash';
import { DateRange } from 'react-date-range';
import NotificationSystem from 'react-notification-system';

import Select from 'components/Form/Select';
import Header from 'components/Header';
import Input from 'components/Form/Input';
import LargeDataTable from 'components/Tables/LargeDataTable';
import Card from 'components/Card';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';
import { CSVExport, downloadCSV } from 'components/CSVExport';
import { getApplications, downloadJSONFromPresign } from 'actions/application';
import { appConfig } from 'config/appConfig';
import { formatCurrency } from 'utils/formatCurrency';

import style from './style.scss';

const initialFilter = {
  applicationId: '',
  applicantName: '',
  applicationDate: '',
  merchantName: '',
  statusLabel: '',
  statusAlias: '',
  statusName: '',
  fundedAmount: '',
  purpose: '',
  merchant: '',
  assignedId: '',
  query: '',
  offset: 0,
  limit: appConfig.limit,
};

let fslExportSocket = null;
let fslExportTimer = null;
const NORMAL_CLOSE = 'Normal Close';
const query = {
  sortBy: 'InitiatedDate.DateTime',
  sortOrder: 'desc',
};

const ApplicationReview = (props) => {
  const dispatch = useDispatch();
  const cellButtonHandler = (index, row) => {
    if (get(row, 'statusAlias') === 'Prospect') {
      props.history.push(`/dashboard/email-app?applicationId=${row.applicationId}`);
    } else {
      props.history.push(`/dashboard/todo-list?applicationId=${row.applicationId}`);
    }
  };
  const [loading, setLoading] = useState(true);
  const [initialLoadFinished, setInitialLoadFinished] = useState(false);
  const [rowCount, setRowCount] = useState(1);
  const [rows, setRows] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [searchValue, setSearchValue] = useState(props.match.params.searchQuery);
  const [documentTags, setDocumentTags] = useState(props.match.params.documentTags || null);
  const [filterObj, setFilterObj] = useState(initialFilter);
  const [dateRange, setDateRange] = useState({
    selection: {
      startDate: new Date(),
      endDate: null,
      key: 'selection',
    },
  });
  const [dateRangeTmp, setDateRangeTmp] = useState({});
  const [isDateRangeSet, setIsDateRangeSet] = useState(false);
  const [isDateRangeVisible, setIsDateRangeVisible] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [allMerchantIds, setAllMerchantIds] = useState([]);
  const [merchantOptions, setMerchantOptions] = useState([]);

  const columns = [
    { name: 'applicationId', title: 'Applicant ID', type: 'link', valueType: 'number' },
    { name: 'clientId', title: 'Client ID', type: 'text' },
    { name: 'merchantName',
      title: 'Merchant',
      type: 'select',
      options: merchantOptions },
    { name: 'applicantName', title: 'Applicant Name', type: 'text', valueType: 'text' },
    { name: 'initiatedDate', title: 'Initiated Date', type: 'date', width: 150 },
    { name: 'applicationDate', title: 'Application Date', type: 'date', width: 150 },
    { name: 'statusAlias', title: 'Application Status', type: 'status', width: 180, valueType: 'text' },
    { name: 'requestedAmount', title: 'Requested Amt', type: 'text', width: 180, valueType: 'number' },
    { name: 'maxApprovalAmount', title: 'Max Approval Amount', type: 'text', width: 200, valueType: 'number' },
    { name: 'fundedDate', title: 'Funded Date', type: 'date', width: 150 },
    { name: 'agent', title: 'Agent', type: 'text', width: 180 },
    {
      name: '',
      title: '',
      type: 'buttons',
      moreOptions: {
        buttonClick: cellButtonHandler,
        buttons: [
          {
            title: 'Take Action',
            className: 'takeAction',
          },
        ],
      },
      width: 130,
    },
  ];
  const filters = JSON.parse(localStorage.getItem('filters'));
  const notificationSystem = useRef(null);

  const txtDateRange = useMemo(() => {
    if (isDateRangeSet) {
      const { selection: { startDate, endDate } } = dateRange;
      return `${
        format(new Date(startDate), 'MM/dd/yyyy')} - ${endDate
        ? format(new Date(endDate), 'MM/dd/yyyy')
        : format(new Date(startDate), 'MM/dd/yyyy')
      }`;
    }
    return '';
  }, [isDateRangeSet, dateRange]);

  const getParameter = (selectedValueArg, filterObjArg, searchValueArg, dateRangeArg, queryArg = {}) => {
    const selectedQuery = get(selectedValueArg, 'attributes.query');
    const newQuery = { ...selectedQuery, ...queryArg };
    delete newQuery.applicationDateOffsetEnd;
    const urlEncode = (obj) => {
      Object.keys(obj).forEach((key) => {
        const str = (typeof obj[key] === 'object') ? JSON.stringify(obj[key]) : obj[key];
        // eslint-disable-next-line no-param-reassign
        obj[key] = str;
      });
      return obj;
    };
    const ret = {
      filterObjArg,
      search: searchValueArg,
      queryArg: urlEncode(newQuery),
      dateRangeArg: dateRangeArg ? {
        startDate: format(new Date(dateRangeArg.selection.startDate), 'yyyy-MM-dd'),
        endDate: dateRange.selection.endDate ? format(new Date(dateRangeArg.selection.endDate), 'yyyy-MM-dd') : format(new Date(dateRangeArg.selection.startDate), 'yyyy-MM-dd'),
      } : null,
    };
    return ret;
  };

  const prepareMerchantData = () => {
    const merchantId = localStorage.getItem('merchantId');
    const businessName = localStorage.getItem('businessName');
    const subMerchants = localStorage.getItem('subMerchants');
    setAllMerchantIds([merchantId]);
    setMerchantOptions([{
      label: businessName,
      value: merchantId,
    }]);
    if (subMerchants) {
      const subMerchantsData = JSON.parse(subMerchants) || [];
      const merchantIds = subMerchantsData.map(item => item.merchantId);
      setAllMerchantIds(prev => [...prev, ...merchantIds]);
      const options = subMerchantsData.map(item => ({
        label: item.businessName,
        value: item.merchantId,
      }));
      setMerchantOptions(prev => [...prev, ...options]);
    }
  };

  const getApplicationsData = ({
    filterObjArg = initialFilter,
    search = '',
    queryArg = { sortBy: 'InitiatedDate.DateTime', sortOrder: 'desc' },
    dateRangeArg = null,
  }) => {
    const filtersTemp = [];

    filtersTemp[0] = (filterObjArg.applicationId !== '') ? `applicationId=${filterObjArg.applicationId}&` : '';
    filtersTemp[1] = (filterObjArg.clientId !== '' && filterObjArg.clientId !== undefined) ? `channelAttributesClientId=${filterObjArg.clientId}&` : '';
    filtersTemp[2] = (filterObjArg.applicantName !== '') ? `applicantName=${filterObjArg.applicantName}&` : '';
    filtersTemp[3] = (filterObjArg.initiatedDate !== '' && filterObjArg.initiatedDate !== undefined) ? `InitiatedDate=${filterObjArg.initiatedDate}&` : '';
    filtersTemp[4] = (filterObjArg.applicationDate !== '' && filterObjArg.applicationDate !== undefined) ? `ApplicationDate=${filterObjArg.applicationDate}&` : '';
    filtersTemp[5] = (filterObjArg.statusLabel !== '') ? `statusLabel=${filterObj.statusLabel}&` : '';
    filtersTemp[6] = (filterObjArg.requestedAmount !== '' && filterObjArg.requestedAmount !== undefined) ? `requestedAmount=${filterObjArg.requestedAmount}&` : '';
    filtersTemp[7] = (filterObjArg.maxApprovalAmount !== '' && filterObjArg.maxApprovalAmount !== undefined) ? `MaxApprovalAmount=${filterObjArg.maxApprovalAmount}&` : '';
    filtersTemp[8] = filterObjArg.merchantName ? `merchantId=${filterObjArg.merchantName.value}&` : (localStorage.getItem('merchantId') ? (allMerchantIds.length > 0 ? `merchantId=${allMerchantIds.join()}&` : `merchantId=${localStorage.getItem('merchantId')}&`) : `merchantId=${null}&`);
    filtersTemp[9] = queryArg !== '' ? `${map(queryArg, (value, key) => `${key}=${value}`).join('&')}&` : '';
    filtersTemp[10] = (filterObjArg.fundedDate !== '' && filterObjArg.fundedDate !== undefined) ? `FundedDate=${filterObjArg.fundedDate}&` : '';
    filtersTemp[11] = (filterObjArg.agent !== '' && filterObjArg.agent !== undefined) ? `agent=${filterObjArg.agent}&` : '';
    let terms = '';
    if (search !== '') { terms = `Terms=${search}&`; }

    if (documentTags) { filtersTemp[12] = `DocumentTags=${documentTags}&`; }
    if (dateRangeArg) {
      const InitiatedDateRangeEnd = `${dateRangeArg.endDate} 23:59:59`;
      filtersTemp[13] = `InitiatedDateRange.Start=${dateRangeArg.startDate}&InitiatedDateRange.End=${InitiatedDateRangeEnd}&`;
    }

    let url = encodeURI(`/applications-view/search?${filtersTemp.join('')}${terms}offset=${filterObjArg.offset}&limit=${filterObjArg.limit}`);
    url = url.replaceAll(',', '%2C');
    setLoading(true);
    dispatch(getApplications({
      url,
      success: (res) => {
        const rowsTemp = res.data.map((item) => {
          const {
            applicationId,
            applicantName,
            initiatedDate,
            applicationDate,
            statusAliases,
            statusLabel,
            statusCode,
            agent,
            requestedAmount,
            maxApprovalAmount,
            amtFinanced,
            payout,
            fundedDate,
            intRate,
            monthlyPayment,
            fundedAmount,
            channelAttributes,
            merchantName,
          } = item;

          return {
            applicationId,
            clientId: channelAttributes ? channelAttributes.clientId || '' : '',
            merchantName: merchantName || '-',
            applicantName,
            initiatedDate: initiatedDate ? format(new Date(initiatedDate), 'MM/dd/yyyy') : '-',
            applicationDate: applicationDate ? format(new Date(applicationDate), 'MM/dd/yyyy') : '-',
            statusLabel,
            statusCode,
            statusAlias: statusAliases ? statusAliases.merchantPortal : '',
            agent,
            requestedAmount: requestedAmount && parseFloat(requestedAmount) > 0 ? `$ ${formatCurrency(requestedAmount, 2)}` : '-',
            maxApprovalAmount: maxApprovalAmount && parseFloat(maxApprovalAmount) > 0 ? `$ ${formatCurrency(maxApprovalAmount, 2)}` : '-',
            amtFinanced: amtFinanced || 'No offer selected',
            payout: payout || '-',
            fundedDate: fundedDate ? format(new Date(fundedDate), 'MM/dd/yyyy') : '-',
            intRate: intRate || '-',
            monthlyPayment: monthlyPayment || '-',
            fundedAmount: `$ ${formatCurrency(fundedAmount, 2)}` || '-',
            item,
          };
        });

        setRows(filterObjArg.offset > 0 ? [...rows, ...rowsTemp] : rowsTemp);
        setRowCount(res.pagination.total);
        setLoading(false);
      },
      fail: (err) => {
        setLoading(false);

        if (err.data) {
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: err.data.message,
            level: 'error',
            position: 'tc',
          });
        }
      },
    }));
  };

  const handleSearchClick = (e) => {
    e.preventDefault();
    const filterObjTemp = {
      ...filterObj,
      offset: 0,
    };
    setFilterObj(filterObjTemp);
    const param = getParameter(JSON.parse(selectedValue), filterObjTemp, searchValue, isDateRangeSet ? dateRange : null, { sortBy: 'InitiatedDate.DateTime', sortOrder: 'desc' });
    getApplicationsData(param);
  };

  const handleKeydown = (event) => {
    if (event.keyCode === 13 && event.target.name === 'searchInput') {
      handleSearchClick(event);
    }
  };

  useEffect(() => {
    const { statusCode } = props.match.params;
    const selectedValueIndex = findIndex(get(filters, '0.filters'), item => item.name === statusCode);
    setSelectedValue(JSON.stringify(get(get(filters, '0.filters'), `${selectedValueIndex === -1 ? 0 : selectedValueIndex}`)));
    setInitialLoadFinished(true);
    prepareMerchantData();
  }, []);

  useEffect(() => {
    if (allMerchantIds.length) getApplications(initialFilter);
  }, [allMerchantIds]);

  const exportCSV = (rowsArg) => {
    const csvRows = [];
    // header
    csvRows.push({
      applicantLastName: 'Borrower Last Name',
      applicantFirstName: 'Borrower First Name',
      dscID: 'DSC Client ID',
      fslId: 'Application ID',
      merchantName: 'Merchant',
      status: 'Application Status',
      declinedReason: 'Declined Reason',
      withdrawReason: 'Withdrawn Reason',
      requestedAmount: 'Requested Amt',
      approvalAmount: 'Approved Amount',
      maxRequestedLoanAmount: 'Max Approval Amount',
      initiatedDate: 'Application Initiated Date',
      appDate: 'Application Date',
      statusDate: 'Status Date',
      minEstSettlementDate: 'Min EST SettlementDate',
      fundedDate: 'Funded Date',
      amountFinanced: 'Amount Financed',
      cdaAmount: 'CDA Amount',
      creditorName: 'Original Creditor',
      creditAccountNumberLastFour: 'Account Number (Last 4)',
      currentCreditor: 'Current Creditor',
      settlementId: 'Settlement ID',
      accountBalance: 'Account Balance',
      settlementAmount: 'Settlement Amount',
      settlementDate: 'Settlement Date',
      agent: 'Agent',
      referenceID: 'Reference ID',
    });
    // data
    // eslint-disable-next-line array-callback-return
    rowsArg.map((item) => {
      csvRows.push({
        applicantLastName: item.applicantLastName,
        applicantFirstName: item.applicantFirstName,
        dscID: item.clientId,
        fslId: item.fslId,
        merchantName: item.merchantName,
        status: item.statusAlias,
        declinedReason: item.declinedReason,
        withdrawReason: item.withdrawReason,
        requestedAmount: item.requestedAmount,
        approvalAmount: item.approvalAmount,
        maxRequestedLoanAmount: item.maxRequestedLoanAmount,
        initiatedDate: item.initiatedDate,
        appDate: item.applicationDate,
        statusDate: item.statusDate,
        minEstSettlementDate: item.minEstSettlementDate,
        fundedDate: item.fundedDate,
        amountFinanced: item.amountFinanced,
        cdaAmount: item.cdaAmount,
        creditorName: item.creditorName,
        creditAccountNumberLastFour: item.creditAccountNumberLastFour,
        currentCreditor: item.currentCreditor,
        settlementId: item.settlementId,
        accountBalance: item.accountBalance,
        settlementAmount: item.settlementAmount,
        settlementDate: item.settlementDate,
        agent: item.agent,
        referenceID: item.referenceId,
      });
    });
    setIsDisabled(false);
    notificationSystem.current
    && notificationSystem.current.addNotification({
      message: 'Your request is complete',
      level: 'success',
      position: 'tc',
    });
    downloadCSV(csvRows, 'applications.csv');
  };

  const exportApplication = (preSignedUrl) => {
    dispatch(downloadJSONFromPresign({
      url: preSignedUrl,
      success: async (res, status) => {
        if (status === 200) {
          const rowsTemp = res.map(item => ({
            fslId: get(item, 'ApplicationId') || '--',
            clientId: get(item, 'ChannelAttributes.ClientId') || '--',
            merchantName: get(item, 'merchantName') || '-',
            applicantFirstName: get(item, 'ApplicantFirstName') || '--',
            applicantLastName: get(item, 'ApplicantLastName') || '--',
            initiatedDate: get(item, 'InitiatedDate') ? format(new Date(get(item, 'InitiatedDate')), 'MM/dd/yyyy') : '--',
            statusLabel: get(item, 'StatusLabel') || '--',
            statusAlias: get(item, 'StatusLabel') || '--',
            requestedAmount: get(item, 'RequestedAmount') ? `$ ${formatCurrency(get(item, 'RequestedAmount'), 2)}` : '--',
            approvalAmount:
              get(item, 'ApprovalAmount') && parseFloat(get(item, 'ApprovalAmount')) > 0
                ? `$ ${formatCurrency(get(item, 'ApprovalAmount'), 2)}`
                : '--',
            maxRequestedLoanAmount: get(item, 'MaxRequestedLoanAmount')
              ? `$ ${formatCurrency(get(item, 'MaxRequestedLoanAmount'), 2)}`
              : '--',
            applicationDate: get(item, 'ApplicationDate')
              ? format(new Date(get(item, 'ApplicationDate')), 'MM/dd/yyyy')
              : '--',
            statusDate: get(item, 'StatusDate')
              ? format(new Date(get(item, 'StatusDate')), 'MM/dd/yyyy')
              : '--',
            minEstSettlementDate: get(item, 'MinEstSettlementDate')
              ? format(new Date(get(item, 'MinEstSettlementDate')), 'MM/dd/yyyy')
              : '--',
            fundedDate: get(item, 'FundedDate')
              ? format(new Date(get(item, 'FundedDate')), 'MM/dd/yyyy')
              : '--',
            amountFinanced: get(item, 'AmountFinanced')
              ? `$ ${formatCurrency(get(item, 'AmountFinanced'), 2)}`
              : '--',
            cdaAmount: get(item, 'channelAttributes.customerDedicatedAccountBalance')
              ? `$ ${formatCurrency(get(item, 'channelAttributes.customerDedicatedAccountBalance'), 2)}`
              : '--',
            creditorName: get(item, 'CreditorName') || '--',
            creditAccountNumberLastFour: get(item, 'CreditAccountNumberLastFour') || '--',
            currentCreditor: get(item, 'CurrentCreditor') || '--',
            declinedReason: get(item, 'DeclinedReason') || '--',
            withdrawReason: get(item, 'WithdrawReason') || '--',
            settlementId: get(item, 'SettlementId') || '--',
            accountBalance: get(item, 'AccountBalance')
              ? `$ ${formatCurrency(get(item, 'AccountBalance'), 2)}`
              : '--',
            settlementAmount: get(item, 'SettlementAmount')
              ? `$ ${formatCurrency(get(item, 'SettlementAmount'), 2)}`
              : '--',
            settlementDate: get(item, 'SettlementDate')
              ? format(new Date(get(item, 'SettlementDate')), 'MM/dd/yyyy')
              : '--',
            maxApprovalAmount: get(item, 'MaxRequestedLoanAmount') && parseFloat(get(item, 'MaxRequestedLoanAmount')) > 0
              ? `$ ${formatCurrency(get(item, 'MaxRequestedLoanAmount'), 2)}` : '-',
            amtFinanced: get(item, 'AmountFinanced') || 'No offer selected',
            payout: get(item, 'Payout') || '--',
            intRate: get(item, 'intRate') || '--',
            monthlyPayment: get(item, 'monthlyPayment') || '--',
            fundedAmount: `$ ${formatCurrency(get(item, 'FundedAmount'), 2)}` || '--',
            agent: get(item, 'Agent' || '--'),
            referenceId: get(item, 'ReferenceId' || ''),
            item,
          }));
          exportCSV(rowsTemp);
        } else {
          setIsExporting(false);
          setIsDisabled(false);
          fslExportTimer && clearTimeout(fslExportTimer);
          fslExportSocket && fslExportSocket.close(1000, NORMAL_CLOSE);
          fslExportSocket = null;
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: 'Something went wrong',
            level: 'error',
            position: 'tc',
          });
        }
      },
      fail: (err) => {
        setIsExporting(false);
        setIsDisabled(false);
        fslExportTimer && clearTimeout(fslExportTimer);
        fslExportSocket && fslExportSocket.close(1000, NORMAL_CLOSE);
        fslExportSocket = null;
        if (err.data) {
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: err.data.message,
            level: 'error',
            position: 'tc',
          });
        }
      },
    }));
  };

  const filterHandler = (queries) => {
    const filterObjTemp = {
      applicationId: queries.keys[0].data,
      clientId: queries.keys[1].data,
      merchantName: queries.keys[2].data,
      applicantName: queries.keys[3].data,
      initiatedDate: queries.keys[4].data !== '' ? format(new Date(queries.keys[4].data), 'yyyy-MM-dd') : '',
      applicationDate: queries.keys[5].data !== '' ? format(new Date(queries.keys[5].data), 'yyyy-MM-dd') : '',
      statusLabel: queries.keys[6].data,
      requestedAmount: queries.keys[7].data,
      maxApprovalAmount: queries.keys[8].data,
      fundedDate: queries.keys[9].data !== '' ? format(new Date(queries.keys[9].data), 'yyyy-MM-dd') : '',
      agent: queries.keys[10].data,
      offset: queries.pageOffset,
      limit: queries.pageLength,
    };
    const { sorting } = queries;
    query.sortBy = sorting.columnName;
    query.sortOrder = sorting.direction;

    const param = getParameter(JSON.parse(selectedValue), filterObjTemp, searchValue, isDateRangeSet ? dateRange : null, query);
    getApplicationsData(param);
    setFilterObj(filterObjTemp);
  };

  const handleFilterChange = (e) => {
    const selectedValueTemp = e.target.value;
    const filterObjTemp = {
      ...filterObj,
      offset: 0,
    };
    setFilterObj(filterObjTemp);
    setSelectedValue(selectedValueTemp);
    const param = getParameter(JSON.parse(selectedValueTemp), filterObjTemp, searchValue, isDateRangeSet ? dateRange : null, { sortBy: 'InitiatedDate.DateTime', sortOrder: 'desc' });
    getApplicationsData(param);
  };

  const handleReset = (e) => {
    e.preventDefault();

    setSelectedValue(null);
    setSearchValue('');
    setDocumentTags(null);
    setIsDateRangeSet(false);
    setDateRangeTmp({
      selection: {
        startDate: new Date(),
        endDate: null,
        key: 'selection',
      },
    });
    const { statusCode } = props.match.params;
    const selectedValueIndex = findIndex(get(filters, '0.filters'), item => item.name === statusCode);
    const selectedValueTemp = JSON.stringify(get(get(filters, '0.filters'), `${selectedValueIndex === -1 ? 0 : selectedValueIndex}`));
    setSelectedValue(selectedValueTemp);
    const filterObjTemp = {
      ...filterObj,
      offset: 0,
    };
    setFilterObj(filterObjTemp);
    const param = getParameter(JSON.parse(selectedValueTemp), filterObjTemp, '', null, { sortBy: 'InitiatedDate.DateTime', sortOrder: 'desc' });
    getApplicationsData(param);
  };

  const handleChange = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  const handleRangeField = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDateRangeVisible(true);
    setDateRangeTmp({ ...dateRange });
  };

  const handleRangeChange = (payload) => {
    setDateRangeTmp(payload);
  };

  const handleApplyDateRange = () => {
    const filterObjTmp = {
      ...filterObj,
      offset: 0,
    };
    const dateRangeAux = { ...dateRangeTmp };
    setIsDateRangeSet(true);
    setIsDateRangeVisible(false);
    setDateRange(dateRangeAux);
    setFilterObj(filterObjTmp);
    const param = getParameter(JSON.parse(selectedValue), filterObjTmp, searchValue, dateRangeAux, { sortBy: 'InitiatedDate.DateTime', sortOrder: 'desc' });
    getApplicationsData(param);
  };

  const handleCloseDateRange = () => {
    setIsDateRangeVisible(false);
  };

  const proceedExport = async ({ exportId, preSignedUrl }) => {
    fslExportSocket = new WebSocket(`${appConfig.fslExportSocketUrl}?application_id=${exportId}`);
    fslExportSocket.addEventListener('message', (event) => {
      const eventData = JSON.parse(get(event, 'data'));
      const eventType = get(eventData, 'EventType');
      if (eventType === 'FSLEXPORT') {
        const success = get(eventData, 'EventData.Success');
        fslExportTimer && clearTimeout(fslExportTimer);
        fslExportSocket && fslExportSocket.close(1000, NORMAL_CLOSE);
        fslExportSocket = null;

        if (success === 'true') {
          exportApplication(preSignedUrl);
        } else {
          setIsExporting(false);
          setIsDisabled(false);
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: get(eventData, 'EventData.Error', 'Something went wrong'),
            level: 'error',
            position: 'tc',
          });
        }
      }
    });

    fslExportSocket.addEventListener('close', (event) => {
      if (get(event, 'reason') !== NORMAL_CLOSE || get(event, 'code') !== 1000) {
        proceedExport({ exportId, preSignedUrl });
      }
    });
  };

  const handleCSVExport = () => {
    const param = getParameter(JSON.parse(selectedValue), filterObj, searchValue, isDateRangeSet ? dateRange : null, query);
    const { filterObjArg: filterObjTemp, queryArg: queryTemp } = param;
    const filtersTemp = [];
    filtersTemp[0] = (filterObjTemp.applicationId !== '') ? `ApplicationId=${filterObjTemp.applicationId}&` : '';
    filtersTemp[1] = (filterObjTemp.clientId !== '') ? `channelAttributesClientId=${filterObjTemp.clientId}&` : '';
    filtersTemp[2] = (filterObjTemp.applicantName !== '') ? `applicantName=${filterObjTemp.applicantName}&` : '';
    filtersTemp[3] = (filterObjTemp.initiatedDate !== '' && filterObjTemp.initiatedDate !== undefined) ? `InitiatedDate=${filterObjTemp.initiatedDate}&` : '';
    filtersTemp[4] = (filterObjTemp.applicationDate !== '' && filterObjTemp.applicationDate !== undefined) ? `ApplicationDate=${filterObjTemp.applicationDate}&` : '';
    filtersTemp[5] = (filterObjTemp.statusLabel !== '') ? `statusLabel=${filterObjTemp.statusLabel}&` : '';
    filtersTemp[6] = (filterObjTemp.requestedAmount !== '' && filterObjTemp.requestedAmount !== undefined) ? `ApprovalAmount=${filterObjTemp.requestedAmount}&` : '';
    filtersTemp[7] = (filterObjTemp.maxApprovalAmount !== '' && filterObjTemp.maxApprovalAmount !== undefined) ? `MaxApprovalAmount=${filterObjTemp.maxApprovalAmount}&` : '';
    filtersTemp[8] = filterObjTemp.merchantName ? `merchantId=${filterObjTemp.merchantName.value}&` : (localStorage.getItem('merchantId') ? (allMerchantIds.length > 0 ? `merchantId=${allMerchantIds.join()}&` : `merchantId=${localStorage.getItem('merchantId')}&`) : `merchantId=${null}&`);
    filtersTemp[9] = (filterObjTemp.fundedDate !== '' && filterObjTemp.fundedDate !== undefined) ? `FundedDate=${filterObjTemp.fundedDate}&` : '';
    filtersTemp[10] = (filterObjTemp.agent !== '' && filterObjTemp.agent !== undefined) ? `agent=${filterObjTemp.agent}&` : '';

    filtersTemp[11] = queryTemp !== '' ? `${map(queryTemp, (value, key) => `${key}=${value}`).join('&')}&` : '';

    let terms = '';
    if (searchValue) { terms = `SearchTerms=${searchValue}&`; }

    if (documentTags) { filtersTemp[12] = `DocumentTags=${documentTags}&`; }
    if (dateRange && isDateRangeSet) {
      const startDate = format(new Date(dateRange.selection.startDate), 'yyyy-MM-dd');
      const endDate = dateRange.selection.endDate ? format(new Date(dateRange.selection.endDate), 'yyyy-MM-dd') : format(new Date(dateRange.selection.startDate), 'yyyy-MM-dd');
      filtersTemp[13] = `InitiatedDateRange.Start=${startDate}&InitiatedDateRange.End=${endDate} 23:59:59&`;
    }

    const url = encodeURI(`/export/fsl?${filtersTemp.join('')}${terms}&offset=0`);
    setIsExporting(true);
    setIsDisabled(true);
    dispatch(getApplications({
      url,
      success: (res) => {
        setIsExporting(false);
        if (res) {
          fslExportTimer = setTimeout(
            () => {
              exportApplication(get(res, 'preSignedUrl'));
            },
            appConfig.fslExportInterval.total
          );
          proceedExport(res);
        }
      },
      fail: (err) => {
        setIsExporting(false);
        if (err.response) {
          notificationSystem.current
          && notificationSystem.current.addNotification({
            message: err.response.data.message,
            level: 'error',
            position: 'tc',
          });
          setIsDisabled(false);
        }
      },
    }));
  };

  return initialLoadFinished && (
    <Fragment>
      <Header />
      <NotificationSystem ref={notificationSystem} />
      <section className="container section">
        <div className="grid-container fluid portal page-applications">
          <Grid>
            <Column className="small-12 card-grid-container">

              <Grid className={cn('grid-margin-x page-header', style.noTopMargin)}>
                <Column className="small-12">
                  <h3>Application Review</h3>
                </Column>
                <Column className="small-12 large-3">
                  <Select
                    name="form-field-name"
                    value={selectedValue}
                    onChange={handleFilterChange}
                    placeHolder="All Applications"
                    data={get(filters, '0.filters').map(item => ({
                      value: JSON.stringify(item),
                      title: item.attributes.alias ? item.attributes.alias : item.label,
                    }))}
                    hasDefault={false}
                    isErrorVisible={false}
                  />
                </Column>
                <Column className="small-12 large-3 search-input">
                  <Input
                    onChange={handleChange}
                    placeHolder="Search"
                    value={searchValue}
                    name="searchInput"
                    onKeyDown={handleKeydown}
                  />
                  <Button
                    className="button green arrow"
                    onClick={handleSearchClick}
                  />
                </Column>
                <Column className={cn('small-12 large-4')}>
                  <div className={cn('position-relative', style.pr150)}>
                    <Input
                      placeHolder="Select App. Date Range"
                      value={txtDateRange}
                      name="searchInput"
                      className="mb-0"
                      onClick={handleRangeField}
                    />
                    {
                      isDateRangeVisible &&
                        <div className="applicationDateRange">
                          <DateRange
                            onChange={handleRangeChange}
                            moveRangeOnFirstSelection={false}
                            ranges={[dateRangeTmp.selection]}
                            endDatePlaceholder="Today"
                          />
                          <div
                            className="btnToolbar"
                          >
                            <Button
                              className={cn('button green', style.mr20)}
                              onClick={handleApplyDateRange}
                            >
                              Apply
                            </Button>
                            <Button
                              className={cn('button green')}
                              onClick={handleCloseDateRange}
                            >
                              Close
                            </Button>
                          </div>
                        </div>
                    }
                    <div className={style.resetBtn}>
                      <Button
                        className={cn('button green')}
                        onClick={handleReset}
                      >
                        Reset Filters
                      </Button>
                    </div>
                  </div>
                </Column>
                <Column className="small-12 large-2 text-right">
                  <CSVExport
                    className="button green"
                    onClick={handleCSVExport}
                    isLoading={isExporting || isDisabled}
                    isDisabled={isDisabled}
                    title="Export"
                  />
                </Column>
              </Grid>

              <Card title="All Applications">
                <LargeDataTable
                  key="filterTable_default"
                  className="grid-x card-table"
                  columns={columns}
                  defaultSorting={[{ columnName: query.sortBy, direction: query.sortOrder }]}
                  pageOffset={{ offset: filterObj.offset, limit: filterObj.limit }}
                  hasGrouping
                  hasSorting
                  hasStatusAlias
                  loading={loading}
                  rows={rows}
                  rowCount={rowCount}
                  onFilter={(queries, isInitial, isHeaderTag) => { filterHandler(queries, isInitial, isHeaderTag); }}
                  infiniteScroll
                />
              </Card>
            </Column>
          </Grid>
        </div>
      </section>
    </Fragment>
  );
};

ApplicationReview.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

ApplicationReview.defaultProps = {

};

export default withRouter(ApplicationReview);



// WEBPACK FOOTER //
// ./src/containers/pages/ApplicationReview/index.js